import React from "react";
import { AdminPurchaseData } from "./Table";


interface AdminPurchaseDetailsModalProps {
  selectedRow: AdminPurchaseData;
  onClose: () => void;
}

const AdminPurchaseDetailsModal: React.FC<AdminPurchaseDetailsModalProps> = ({
  selectedRow,
  onClose,
}) => {
  const initials = selectedRow.user_name
    .split(" ")
    .map((word) => word.charAt(0).toUpperCase())
    .join("")
    .slice(0, 2); // Get first two initials

  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50 p-4">
      <div className="bg-white rounded-xl shadow-2xl max-w-lg w-full p-6 sm:p-8 relative border border-blue-200">
        {/* Close Button */}
        <button
          onClick={onClose}
          className="absolute top-4 right-4 text-blue-600 hover:text-blue-800 transition-colors duration-200"
          aria-label="Close modal"
        >
          <svg
            className="w-6 h-6"
            fill="none"
            stroke="currentColor"
            viewBox="0 0 24 24"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth="2"
              d="M6 18L18 6M6 6l12 12"
            />
          </svg>
        </button>

        {/* Modal Header */}
        <div className="flex items-center gap-3 mb-6">
          <div className="flex items-center justify-center w-12 h-12 rounded-full bg-blue-500 text-white text-lg font-semibold">
            {initials}
          </div>
          <h2 className="text-xl sm:text-2xl font-bold text-blue-900">
            {selectedRow.user_name}
          </h2>
        </div>

        {/* Modal Content */}
        <div className="space-y-4">
          <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
            <div>
              <label className="text-sm font-medium text-blue-700">ID</label>
              <p className="text-base text-gray-900">{selectedRow.id}</p>
            </div>
            <div>
              <label className="text-sm font-medium text-blue-700">Phone Number</label>
              <p className="text-base font-mono text-gray-900">{selectedRow.msisdn}</p>
            </div>
            <div>
              <label className="text-sm font-medium text-blue-700">Network</label>
              <p
                className={`text-base font-medium ${
                  selectedRow.network === "MTN"
                    ? "text-yellow-700"
                    : selectedRow.network === "Airtel"
                    ? "text-red-700"
                    : selectedRow.network === "Glo"
                    ? "text-green-700"
                    : selectedRow.network === "9Mobile"
                    ? "text-purple-700"
                    : "text-gray-900"
                }`}
              >
                {selectedRow.network}
              </p>
            </div>
            <div>
              <label className="text-sm font-medium text-blue-700">Amount</label>
              <p className="text-base text-gray-900">{selectedRow.amount}</p>
            </div>
            <div>
              <label className="text-sm font-medium text-blue-700">Status</label>
              <p
                className={`text-base font-medium ${
                  selectedRow.status === "completed"
                    ? "text-green-700"
                    : selectedRow.status === "pending"
                    ? "text-yellow-700"
                    : selectedRow.status === "failed"
                    ? "text-red-700"
                    : "text-gray-900"
                }`}
              >
                {selectedRow.status}
              </p>
            </div>
            <div>
              <label className="text-sm font-medium text-blue-700">Timestamp</label>
              <p className="text-base text-gray-900">
                {new Date(selectedRow.created_at).toLocaleString()}
              </p>
            </div>
            <div className="sm:col-span-2">
              <label className="text-sm font-medium text-blue-700">Mobile Originated (MO)</label>
              <p className="text-base text-gray-900 bg-blue-50 p-2 rounded-md">
                {selectedRow.mo}
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AdminPurchaseDetailsModal;